export default __webpack_public_path__ + "static/media/goal.ef5902af.png";